module.exports = __webpack_public_path__ + "media/images/activity_plus_icon-a84bbabbdd353e18532250eeeb5dea62.png";